import { render, staticRenderFns } from "./CompletionPage.vue?vue&type=template&id=2ea3f491&scoped=true"
import script from "./CompletionPage.vue?vue&type=script&lang=js"
export * from "./CompletionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3f491",
  null
  
)

export default component.exports